/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface TeamActivityEmployee
 */
export interface TeamActivityEmployee {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TeamActivityEmployee
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof TeamActivityEmployee
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof TeamActivityEmployee
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof TeamActivityEmployee
     */
    role: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TeamActivityEmployee
     */
    count: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the TeamActivityEmployee interface.
 */
export function instanceOfTeamActivityEmployee(value: object): value is TeamActivityEmployee {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function TeamActivityEmployeeFromJSON(json: any): TeamActivityEmployee {
    return TeamActivityEmployeeFromJSONTyped(json, false);
}

export function TeamActivityEmployeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamActivityEmployee {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'role': json['role'],
        'count': ApiUserTasksGetPageParameterFromJSON(json['count']),
    };
}

export function TeamActivityEmployeeToJSON(json: any): TeamActivityEmployee {
    return TeamActivityEmployeeToJSONTyped(json, false);
}

export function TeamActivityEmployeeToJSONTyped(value?: TeamActivityEmployee | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'role': value['role'],
        'count': ApiUserTasksGetPageParameterToJSON(value['count']),
    };
}

